package app.footyguide.web.data

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.app
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.initialize
import dev.gitlive.firebase.firestore.FirebaseFirestore
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.firestore.firestoreSettings

object FirestoreDatabase {
    const val DEV = "footyguide-dev"
    const val PROD = "footyguide-prod"
    private var cachedInstance: FirebaseFirestore? = null
    private var cachedDatabaseId: String? = null
    private var cachedApp = false

    fun resolve(configuredId: String): String {
        require(configuredId == DEV || configuredId == PROD) {
            "Unknown Firestore database: '$configuredId'"
        }
        return configuredId
    }

    fun configuredId(): String {
        val config = js("window.__FOOTYGUIDE_CONFIG__")
        require(config != null && config != undefined) { "__FOOTYGUIDE_CONFIG__ not found" }
        return resolve(config.database as? String ?: "")
    }

    fun instance(): FirebaseFirestore {
        val config = js("window.__FOOTYGUIDE_CONFIG__")
        val databaseId = configuredId()
        if (cachedDatabaseId == databaseId) cachedInstance?.let { return it }
        val firebase = config.firebaseConfig
        if (!cachedApp) {
            Firebase.initialize(
                null,
                FirebaseOptions(
                    applicationId = firebase.appId as String,
                    apiKey = firebase.apiKey as String,
                    projectId = firebase.projectId as String,
                    storageBucket = firebase.storageBucket as? String,
                    gcmSenderId = firebase.messagingSenderId as? String,
                    authDomain = firebase.authDomain as? String,
                ),
            )
            cachedApp = true
        }
        val firestore = Firebase.firestore(Firebase.app, databaseId)
        firestore.settings = firestoreSettings { }
        if (config.useEmulator == true) {
            val host = config.emulatorHost as? String ?: "localhost"
            val port = (config.emulatorPort as? Number)?.toInt() ?: 8181
            firestore.useEmulator(host, port)
        }
        cachedDatabaseId = databaseId
        cachedInstance = firestore
        return firestore
    }

    suspend fun authenticate() {
        val auth = Firebase.auth
        if (auth.currentUser == null) auth.signInAnonymously()
    }
}
